import type { WithStyles } from "@envestnet/envreact-component-library";
import { createStyles } from "@envestnet/envreact-component-library";

const styles = () =>
  createStyles({
    container: {},
    mfaCenter: {
      "& > div": {
        marginTop: "unset",
        width: "unset",
        minWidth: 360,
        marginBottom: "unset",
      },
    },
  });

export type Styles = WithStyles<typeof styles>;
export default styles;
